import Swiper from 'swiper/swiper-bundle';
import 'swiper/swiper-bundle.min.css';

const cardCtaSwipers = document.querySelectorAll('.card-ctas__swiper');

if (cardCtaSwipers) {
	cardCtaSwipers.forEach(cardSwiper => {
		const cardType = cardSwiper.querySelectorAll('.card-cta--logo').length > 0 ? 'logo' : 'content';

		const options = {
			slidesPerView: 'auto',
			spaceBetween: cardType === 'content' ? 35 : 20,
			centeredSlides: false,
			loop: false,
			shortSwipes: false,
			freeMode: true,
			keyboard: {
				enabled: true,
				onlyInViewport: true,
			},
			mousewheel: {
				enabled: true,
				forceToAxis: true,
			},
			breakpoints: {
				576: {
					spaceBetween: cardType === 'content' ? 35 : 25,
					slidesPerView: 'auto',
				},
				768: {
					spaceBetween: cardType === 'content' ? 35 : 30,
					slidesPerView: 'auto',
				},
				992: {
					spaceBetween: cardType === 'content' ? 37 : 35,
					slidesPerView: 3,
				},
				1200: {
					spaceBetween: cardType === 'content' ? 37 : 40,
					slidesPerView: cardType === 'content' ? 3 : 4,
				},
				1400: {
					spaceBetween: cardType === 'content' ? 37 : 45,
					slidesPerView: cardType === 'content' ? 3 : 4,
				},
			},
		};

		const progressBar = cardSwiper.querySelector('.slider-progress-bar');

		if (progressBar) {
			options.pagination = {
				el: progressBar,
				type: 'progressbar',
			};
		}

		const swiper = new Swiper(cardSwiper, options);

		const prevArrow = cardSwiper.querySelector('.js-slider-arrow-prev');
		const nextArrow = cardSwiper.querySelector('.js-slider-arrow-next');

		if (prevArrow) {
			prevArrow.addEventListener('click', () => {
				swiper.slidePrev();
			});
		}

		if (nextArrow) {
			nextArrow.addEventListener('click', () => {
				swiper.slideNext();
			});
		}
	});
}
